import React from "react"
import PropTypes from "prop-types"

class ScrollToPosition  extends React.Component {
  componentDidMount() {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    return(
      <div style={{ float:"left", clear: "both" }}
         ref={(el) => { this.messagesEnd = el; }}>
      </div>
    )
  }
}

export default ScrollToPosition
